import * as tslib_1 from "tslib";
import { Logger } from '@services/logger/abstract.logger';
import { NullableStateManager } from 'main/app-state/generics/state-manager';
import { BehaviorSubject, Observable, } from 'rxjs';
import { distinctUntilChanged, filter, map, tap, } from 'rxjs/operators';
import { isPermissionExpressionGranted } from './permission-expression-parser';
import { PermissionsService } from './permissions.service';
var PermissionsManager = /** @class */ (function (_super) {
    tslib_1.__extends(PermissionsManager, _super);
    function PermissionsManager(injector) {
        var _this = _super.call(this) || this;
        _this._state = new BehaviorSubject(null);
        _this._isFetchPending = false;
        _this._permissionsService = injector.get(PermissionsService);
        // The Injector doesn't work directly with abstract classes, so manual casting to Type<Logger> has to be done.
        // More details: https://github.com/angular/angular/issues/23611
        _this._logStateChanges('Permissions', injector.get(Logger));
        return _this;
    }
    PermissionsManager.prototype.fetch = function () {
        var _this = this;
        this._isFetchPending = true;
        return this._permissionsService.get()
            .pipe(tap(function (data) {
            _this._isFetchPending = false;
            _this._state.next(data);
        }));
    };
    PermissionsManager.prototype.clean = function () {
        var _this = this;
        return new Observable(function (subscriber) {
            _this._isFetchPending = false;
            _this._state.next(null);
            subscriber.next(null);
            subscriber.complete();
        });
    };
    PermissionsManager.prototype.isGranted = function (permissionsExpression) {
        var _this = this;
        return this._state.pipe(filter(function () { return !_this._isFetchPending; }), map(function (permissions) { return isPermissionExpressionGranted(permissions || [], permissionsExpression); }), distinctUntilChanged());
    };
    return PermissionsManager;
}(NullableStateManager));
export { PermissionsManager };
